import { css, cx } from '@linaria/core'
import type { ComponentType, ElementType } from 'react'
import { useSharedAppSelector } from '#store/sharedBaseStore'

export const placeHolderClass = css`
  user-select: none;
  position: relative;
  overflow: visible;

  @media screen {
    &.highlight-placeholders-strike,
    &.highlight-placeholders-overlay {
      cursor: not-allowed;
      text-decoration: line-through !important;

      *,
      *::placeholder {
        text-decoration: line-through !important;
        cursor: not-allowed !important;
      }

      img {
        filter: grayscale(1) blur(0.5px) contrast(0.5);
      }

      select {
        filter: grayscale(1) blur(0.5px) contrast(0.5);
      }

      &:after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-attachment: fixed;
        transition: opacity 0.2s, filter 0.2s;
        opacity: 0;

        // striped background, fade to transparent in the center
        background-image: linear-gradient(
          45deg,
          rgba(255, 0, 255, 0.25) 25%,
          transparent 25%,
          transparent 50%,
          rgba(255, 0, 255, 0.25) 50%,
          rgba(255, 0, 255, 0.25) 75%,
          transparent 75%,
          transparent
        );
        background-size: 1rem 1rem;
      }

      &:hover {
        &:before {
          content: 'Placeholder, not functional';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
          z-index: 100;
          background: #1e2832;
          color: white;
          font-size: 10px;
          border-radius: 4px;
          padding: 2px 4px;
          justify-content: center;
          align-items: center;
          display: flex;
        }
      }
    }
    &.highlight-placeholders-strike {
      &:hover {
        &:after {
          opacity: 0.4;
        }
      }
    }

    &.highlight-placeholders-overlay {
      &:after {
        opacity: 1;
      }
    }
  }
`

export function withPlaceholder<TProps extends { className?: string }, TElem extends ElementType<TProps>>(element: TElem) {
  return function PlaceholderWrapper({ className, ...props }: TProps) {
    const highlightPlaceholders = useSharedAppSelector((x) => x.componentConfiguration.highlightPlaceholders)

    const combinedProps = {
      className: cx(className, placeHolderClass, `highlight-placeholders-${highlightPlaceholders ?? 'no'}`),
      ...props,
    } as TProps
    const Component = element as ComponentType<TProps>
    return <Component {...combinedProps} />
  } as unknown as TElem
}
